const elementType = 'redventures.usertracking.v3.ElementClicked';

const payloads = {
  facebookSocialShare: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'share',
      location: 'share-options',
      position: '1',
      elementType: 'button',
    },
    actionOutcome: 'Open Facebook',
  },
  linkedInSocialShare: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'share',
      location: 'share-options',
      position: '1',
      elementType: 'button',
    },
    actionOutcome: 'Open LinkedIn',
  },
  twitterSocialShare: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'share',
      location: 'share-options',
      position: '1',
      elementType: 'button',
    },
    actionOutcome: 'Open Twitter',
  },
  emailShare: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'share',
      location: 'share-options',
      position: '1',
      elementType: 'button',
    },
    actionOutcome: 'Open Outlook',
  },
  generalLinkShare: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'share',
      location: 'share-options',
      position: '1',
      elementType: 'button',
    },
    actionOutcome: 'Copy Link',
  },
  freeProfileCta: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'profile-page-CTA-link',
      location: 'free-CTA',
      position: '1',
      elementType: 'button',
      text: 'Search all programs',
    },
    actionOutcome: 'Internal Link',
  },
  freeProfileCtaDesktop: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'profile-page-CTA-link',
      location: 'free-CTA',
      position: '1',
      elementType: 'button',
      text: 'Search all programs',
    },
    actionOutcome: 'Internal Link',
  },
  freeProfileScrollCta: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'profile-page-CTA-link',
      location: 'free-CTA',
      position: '1',
      elementType: 'button',
      text: 'Search all programs',
    },
    actionOutcome: 'Internal Link',
  },
  resourceOne: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      text: 'resource',
      name: 'resource',
      location: 'inline-resource',
      position: '3',
      elementType: 'button',
      htmlId: 'position 1',
    },
    actionOutcome: 'Internal Link',
  },
  resourceTwo: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      text: 'resource',
      name: 'resource',
      location: 'inline-resource',
      position: '4',
      elementType: 'button',
      htmlId: 'position 2',
    },
    actionOutcome: 'Internal Link',
  },
  resourceThree: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      text: 'resource',
      name: 'resource',
      location: 'inline-resource',
      position: '4',
      elementType: 'button',
      htmlId: 'position 3',
    },
    actionOutcome: 'Internal Link',
  },
  resourceFour: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'resource',
      location: 'explore-more-resources',
      position: '4',
      elementType: 'button',
      htmlId: 'position 1',
    },
    actionOutcome: 'Internal Link',
  },
  resourceFive: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'resource',
      location: 'explore-more-resources',
      position: '4',
      elementType: 'button',
      htmlId: 'position 2',
    },
    actionOutcome: 'Internal Link',
  },
  resourceSix: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'resource',
      location: 'explore-more-resources',
      position: '4',
      elementType: 'button',
      htmlId: 'position 3',
    },
    actionOutcome: 'Internal Link',
  },
  rankingOne: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'ranking',
      location: 'explore-rankings',
      position: '4',
      elementType: 'button',
      htmlId: 'position 1',
    },
    actionOutcome: 'Internal Link',
  },
  rankingTwo: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'ranking',
      location: 'explore-rankings',
      position: '4',
      elementType: 'button',
      htmlId: 'position 2',
    },
    actionOutcome: 'Internal Link',
  },
  rankingThree: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'ranking',
      location: 'explore-rankings',
      position: '4',
      elementType: 'button',
      htmlId: 'position 3',
    },
    actionOutcome: 'Internal Link',
  },
  internationalTooltip: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'ways-to-learn',
      position: '3',
      elementType: 'tooltip',
      text: 'International',
    },
    actionOutcome: 'Open tooltip',
  },
  hybridTooltip: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'ways-to-learn',
      position: '3',
      elementType: 'tooltip',
      text: 'Hybrid',
    },
    actionOutcome: 'Open tooltip',
  },
  premiumProfileCta: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'profile-page-CTA-link',
      location: 'premium-CTA',
      position: '1',
      elementType: 'Link',
      text: 'Visit School Site',
    },
    actionOutcome: 'Internal Link',
  },
  premiumProfileCtaDesktop: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'profile-page-CTA-link',
      location: 'premium-CTA',
      position: '1',
      elementType: 'Link',
      text: 'Visit School Site',
    },
    actionOutcome: 'Internal Link',
  },
  premiumProfileScrollCta: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'profile-page-CTA-link',
      location: 'premium-CTA',
      position: '1',
      elementType: 'Link',
      text: 'Visit School Site',
    },
    actionOutcome: 'Internal Link',
  },
  linkedArticle: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'Sponsored-content',
      location: 'CTA-section',
      position: '2',
      elementType: 'Link',
      text: document.querySelector('#linkedArticle h2')
        ? document.querySelector('#linkedArticle h2').innerText
        : '',
    },
    actionOutcome: 'Internal Link',
  },
  rankingsShowMore: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'expand',
      location: 'rankings-module',
      position: '1',
      elementType: 'button',
      text: document.querySelector('#rankingsShowMore')
        ? document.querySelector('#rankingsShowMore').innerText
        : '',
    },
    actionOutcome: 'expand list',
  },
  rankingsLink: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'transfer',
      location: 'rankings-module',
      position: '1',
      elementType: 'Link',
      text: '',
    },
    actionOutcome: 'internal link',
  },
  tocAbout: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocAbout')
        ? document.querySelector('#tocAbout').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocAboutMobile: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocAboutMobile')
        ? document.querySelector('#tocAboutMobile').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocCampusLife: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocCampusLife')
        ? document.querySelector('#tocCampusLife').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocCampusLifeMobile: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocCampusLifeMobile')
        ? document.querySelector('#tocCampusLifeMobile').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocAdmissions: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocAdmissions')
        ? document.querySelector('#tocAdmissions').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocAdmissionsMobile: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocAdmissionsMobile')
        ? document.querySelector('#tocAdmissionsMobile').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocTestScores: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocTestScores')
        ? document.querySelector('#tocTestScores').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocTestScoresMobile: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocTestScoresMobile')
        ? document.querySelector('#tocTestScoresMobile').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocDemographics: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocDemographics')
        ? document.querySelector('#tocDemographics').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocDemographicsMobile: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocDemographicsMobile')
        ? document.querySelector('#tocDemographicsMobile').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocFinancialBreakdown: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocFinancialBreakdown')
        ? document.querySelector('#tocFinancialBreakdown').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocFinancialBreakdownMobile: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocFinancialBreakdownMobile')
        ? document.querySelector('#tocFinancialBreakdownMobile').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocResources: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocResources')
        ? document.querySelector('#tocResources').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocResourcesMobile: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocResourcesMobile')
        ? document.querySelector('#tocResourcesMobile').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocRankings: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocRankings')
        ? document.querySelector('#tocRankings').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  tocRankingsMobile: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'bumper',
      location: 'Table-of-contents',
      position: '1',
      elementType: 'Link',
      text: document.querySelector('#tocRankingsMobile')
        ? document.querySelector('#tocRankingsMobile').innerText
        : 'toc-link',
    },
    actionOutcome: 'Interpage Bump',
  },
  b2bLink: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'transfer',
      location: 'B2B-CTA',
      position: '1',
      elementType: 'Link',
      text: "Claim your school's profile",
    },
    actionOutcome: 'Internal Link',
  },
  b2bLinkMobile: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'transfer',
      location: 'B2B-CTA',
      position: '1',
      elementType: 'Link',
      text: "Claim your school's profile",
    },
    actionOutcome: 'Internal Link',
  },
  hbcuTooltip: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'About',
      position: '1',
      elementType: 'tooltip',
      text: 'HBCU',
    },
    actionOutcome: 'Open tooltip',
  },
  religionTooltip: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'About',
      position: '1',
      elementType: 'tooltip',
      text: 'Religious Affiliation',
    },
    actionOutcome: 'Open tooltip',
  },
  militaryFriendlyTooltip: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'About',
      position: '1',
      elementType: 'tooltip',
      text: 'Military Friendly',
    },
    actionOutcome: 'Open tooltip',
  },
  applicationConsiderationsButton: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tab',
      location: 'admissions-breakdown',
      position: '2',
      elementType: 'Tab',
      text: 'Application Considerations',
    },
    actionOutcome: 'Change tab',
  },
  transferCreditButton: {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tab',
      location: 'admissions-breakdown',
      position: '2',
      elementType: 'Tab',
      text: 'Transfer Credit Policy',
    },
    actionOutcome: 'Change tab',
  },
};

const nationalAverages = {
  'Affordable school': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'CTA-section',
      position: '1',
      elementType: 'tooltip',
      text: 'Affordable School',
    },
  },
  'Affordable private school': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'CTA-section',
      position: '1',
      elementType: 'tooltip',
      text: 'Affordable Private School',
    },
  },
  'Affordable public school': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'CTA-section',
      position: '1',
      elementType: 'tooltip',
      text: 'Affordable Public School',
    },
  },
  'Affordable public school (in-state)': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'CTA-section',
      position: '1',
      elementType: 'tooltip',
      text: 'Affordable School',
    },
  },
  'Affordable public school (out-of-state)': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'CTA-section',
      position: '1',
      elementType: 'tooltip',
      text: 'Affordable School',
    },
  },
  'Competitive acceptance rate': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'admissions-breakdown',
      position: '2',
      elementType: 'tooltip',
      text: 'Competitive Acceptance Rate',
    },
  },
  'Highly selective acceptance rate': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'admissions-breakdown',
      position: '2',
      elementType: 'tooltip',
      text: 'Highly Selective Acceptance Rate',
    },
  },
  'High acceptance rate': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'admissions-breakdown',
      position: '2',
      elementType: 'tooltip',
      text: 'High Acceptance Rate',
    },
  },
  'High retention rate': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'admissions-breakdown',
      position: '2',
      elementType: 'tooltip',
      text: 'High Retention Rate',
    },
  },
  'High graduation rate': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'admissions-breakdown',
      position: '2',
      elementType: 'tooltip',
      text: 'High Graduation Rate',
    },
  },
  'Small school size': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'learning-environment',
      position: '3',
      elementType: 'tooltip',
      text: 'Small School Size',
    },
  },
  'Medium school size': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'learning-environment',
      position: '3',
      elementType: 'tooltip',
      text: 'Medium School Size',
    },
  },
  'Large school size': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'learning-environment',
      position: '3',
      elementType: 'tooltip',
      text: 'Large School Size',
    },
  },
  'Low student-to-faculty ratio': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'learning-environment',
      position: '3',
      elementType: 'tooltip',
      text: 'Low Student-to-Faculty Ratio',
    },
  },
  'High average amount awarded': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'Financial Aid Breakdown',
      position: '3',
      elementType: 'tooltip',
      text: 'High Average Amount Awarded',
    },
  },
  'Requires high test scores': {
    type: elementType,
    event: 'ElementClicked',
    webElement: {
      name: 'tooltip',
      location: 'test-scores',
      position: '3',
      elementType: 'tooltip',
      text: 'Requires High Test Scores',
    },
  },
};

export { payloads, nationalAverages };
